module.exports = __webpack_public_path__ + "img/vege.401a3ca6.png";